import React from 'react';
import { Col, Row, Button, Navbar, Container, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Header.css'

const Header = () => {
    return (
        <div>
            <Navbar bg="dark" variant="dark">
                <Container>
                    <Navbar.Brand className="name">Learn With Fun</Navbar.Brand>
                    <Nav className="me-auto">
                        <Link className="link" to="/home">Home</Link>
                        <Link className="link" to="/courses">All Courses</Link>
                        <Link className="link" to="/about">About</Link>
                        <Link className="link" to="/contact">Contact Us</Link>
                    </Nav>
                </Container>
            </Navbar>
        </div>
    );
};

export default Header;